<div class="content-info">
  <div class="zf-doc-head">
    <div class="zf-doc-left">
      <button type="button" (click)="goBack()" class="zf-doc-back"><i class="bi bi-arrow-left"></i> Manufacturers</button>
      <div class="zf-doc-title-row">
        <h4 class="zf-doc-title">{{ isEdit ? "Edit Manufacturer" : "Add Manufacturer" }}</h4>
        @if (isEdit) {
        @if (manufacturerForm.get('code')?.value) {
        <span class="zf-doc-no" title="Manufacturer code">{{ manufacturerForm.get('code')?.value }}</span>
        }
        } @else if (nextCode) {
        <span class="zf-doc-no" title="Manufacturer code, assigned automatically when the manufacturer is created">{{ nextCode }}</span>
        }
      </div>
    </div>
    <div class="zf-doc-actions">
      <button type="button" class="btn btnsecondary" (click)="goBack()">
        Cancel
      </button>
      <button type="button" class="btn btnprimary" (click)="submit()">
        {{ isEdit ? "Update" : "Create" }}
      </button>
    </div>
  </div>

  <div class="input-fields">
    <form [formGroup]="manufacturerForm" novalidate>
      <div class="row">
        <!-- Manufacturer Name -->
        <div class="col-md-6 form-group mb-4">
          <label>Name *</label>
          <input
            type="text"
            formControlName="name"
            class="form-control"
            [class.is-invalid]="
              manufacturerForm.get('name')?.invalid &&
              manufacturerForm.get('name')?.touched
            "
            />
          @if (
            manufacturerForm.get('name')?.invalid &&
            manufacturerForm.get('name')?.touched
            ) {
            <div
              class="invalid-feedback"
              >
              Name is required
            </div>
          }
          @if (isEdit) {
            <small class="text-muted">Fixed once created; saved brand names are fixed too</small>
          }
        </div>

        <!-- Brands -->
        <div class="col-md-12 form-group mb-5">
          <label>Brands{{ req('brands') }}</label>
          <div formArrayName="brands">
            @for (brand of brands.controls; track brand; let i = $index) {
              <div
                class="d-flex align-items-center gap-2 mb-2"
                >
                <input
                  class="form-control"
                  placeholder="Brand Name"
                  [formControlName]="i"
                  [class.is-invalid]="brand.invalid && brand.touched"
                  />
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  (click)="removeBrand(i)"
                  [disabled]="brands.length === 1"
                  >
                  <i class="bi bi-trash3"></i>
                </button>
              </div>
            }
            @if (brandsMissing && submitted) {
              <div
                class="invalid-feedback d-block"
                >
                At least one brand is required
              </div>
            }
          </div>
          <button
            type="button"
            class="btn btn-secondary mt-2"
            (click)="addBrand()"
            >
            + Add Brand
          </button>
        </div>

        <!-- Contacts -->
        <div class="col-md-12 form-group mb-4">
          <label>Contacts{{ req('contacts') }}</label>
          @if (contactsMissing && submitted) {
          <div class="invalid-feedback d-block mb-2">At least one contact is required</div>
          }

          <div formArrayName="contacts">
            @for (contact of contacts.controls; track contact; let i = $index) {
              <div
                [formGroupName]="i"
                class="border rounded p-3 mb-4 bg-light"
                >
                <div class="row g-3">
                  <div class="col-md-3">
                    <label>Role *</label>
                    <select
                      class="form-control"
                      formControlName="role"
                    [class.is-invalid]="
                      contact.get('role')?.invalid &&
                      contact.get('role')?.touched
                    "
                      >
                      <option value="SALES_OFFICER">Sales Officer</option>
                      <option value="ASSISTANT_SM">Assistant SM</option>
                      <option value="REGIONAL_SM">Regional SM</option>
                      <option value="NATIONAL_SM">National SM</option>
                    </select>
                    @if (
                      contact.get('role')?.invalid &&
                      contact.get('role')?.touched
                      ) {
                      <div
                        class="invalid-feedback"
                        >
                        Role is required
                      </div>
                    }
                  </div>
                  <div class="col-md-3">
                    <label>Name{{ req('contactName') }}</label>
                    <input
                      class="form-control"
                      formControlName="name"
                      placeholder="Contact Name"
                    [class.is-invalid]="
                      contact.get('name')?.invalid &&
                      contact.get('name')?.touched
                    "
                      />
                    @if (
                      contact.get('name')?.invalid &&
                      contact.get('name')?.touched
                      ) {
                      <div
                        class="invalid-feedback"
                        >
                        Name is required
                      </div>
                    }
                  </div>
                  <div class="col-md-3">
                    <label>Email{{ req('contactEmail') }}</label>
                    <input
                      class="form-control"
                      formControlName="email"
                      placeholder="Contact Email"
                      type="email"
                    [class.is-invalid]="
                      contact.get('email')?.invalid &&
                      contact.get('email')?.touched
                    "
                      />
                    @if (
                      contact.get('email')?.invalid &&
                      contact.get('email')?.touched
                      ) {
                      <div
                        class="invalid-feedback"
                        >
                        @if (contact.get('email')?.errors?.['required']) {
                          <span
                            >Email is required</span
                            >
                          }
                          @if (contact.get('email')?.errors?.['email']) {
                            <span
                              >Please enter a valid email</span
                              >
                            }
                          </div>
                        }
                      </div>
                      <div class="col-md-3">
                        <label>Phone{{ req('contactPhone') }}</label>
                        <input
                          class="form-control"
                          formControlName="phoneNumber"
                          placeholder="Phone Number"
                    [class.is-invalid]="
                      contact.get('phoneNumber')?.invalid &&
                      contact.get('phoneNumber')?.touched
                    "
                          />
                        @if (
                          contact.get('phoneNumber')?.invalid &&
                          contact.get('phoneNumber')?.touched
                          ) {
                          <div
                            class="invalid-feedback"
                            >
                            Phone is required
                          </div>
                        }
                      </div>
                      <div class="col-md-12 text-end mt-3">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          (click)="removeContact(i)"
                          [disabled]="contacts.length === 1"
                          >
                          <i class="bi bi-trash3"></i> Remove
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <button
                type="button"
                class="btn btn-secondary mt-2"
                (click)="addContact()"
                >
                + Add Contact
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
